const getters = {
  advWireless: (state) => state.settings.wireless.adv,
  supportGuestNetwok: (state) => state.settings.wireless.guestNetwork,
  supportMultiSsid: (state) => state.settings.wireless.multiSsid,
  supportAx: (state) => state.settings.wireless.hasAx,
  supportArmor: (state) => state.settings.armor,
  supportCircle: (state) => state.settings.circle,
  supportAutoTimezone: (state) => state.settings.autoTimezone,
  supportInsight: (state) => state.settings.insight,
  supportBusinessVpn: (state) => state.settings.businessVpn,
  supportAdvWizard: (state) => state.settings.advWizard,
  supportMultiGateway: (state) => state.settings.multiGateway,
  footerHasTncPolicy: (state) => state.settings.footerHasTncPolicy,
};
export default getters;
